// @ts-ignore
import { PixiPlugin } from "gsap/all";
import { Howler } from "howler";
import { Application } from "./scripts/Application";

const pixiPlugin = PixiPlugin; // so it doesn't get tree-shaken
Howler.autoUnlock = false;

const canvasDiv = document.createElement("div");
canvasDiv.setAttribute("id", "gameTarget");
document.body.appendChild(canvasDiv);

const app = Application.instance;

canvasDiv.appendChild(app.view);
app.init();
